var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtendCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.75H27.5V25C27.5 25.3315 27.3683 25.6495 27.1339 25.8839C26.8995 26.1183 26.5815 26.25 26.25 26.25H3.75C3.41848 26.25 3.10054 26.1183 2.86612 25.8839C2.6317 25.6495 2.5 25.3315 2.5 25V13.75ZM21.25 3.75001H26.25C26.5815 3.75001 26.8995 3.88171 27.1339 4.11613C27.3683 4.35055 27.5 4.66849 27.5 5.00001V11.25H2.5V5.00001C2.5 4.66849 2.6317 4.35055 2.86612 4.11613C3.10054 3.88171 3.41848 3.75001 3.75 3.75001H8.75V1.25001H11.25V3.75001H18.75V1.25001H21.25V3.75001Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendCalendar);
export default __webpack_public_path__ + "static/media/ExtendCalendar.31594893b4f8630f77eed7acf024eba5.svg";
export { ForwardRef as ReactComponent };